import React from 'react'

const VantaggiCardContent = ({ className, children, descrizione }) => {
  function createMArkup(testo) {
    return { __html: testo }
  }
  return (
    <div
      dangerouslySetInnerHTML={createMArkup(descrizione)}
      className={'vantaggi-card__list' + (className ? ' ' + className : '')}
    >
      {children}
    </div>
  )
}

const VantaggiCardBottom = ({ className, children }) => {
  return (
    <div className={'vantaggi-card__bottom' + (className ? ' ' + className : '')}>{children}</div>
  )
}

const VantaggiCard = ({ title, children, bottom }) => {
  return (
    <div className="vantaggi-card">
      <p className="vantaggi-card__title">{title}</p>
      {children}
    </div>
  )
}

VantaggiCard.Content = VantaggiCardContent
VantaggiCard.Bottom = VantaggiCardBottom

export default VantaggiCard
